import { render, staticRenderFns } from "./CataloguePostList.vue?vue&type=template&id=cf831b92&lang=pug&"
import script from "./CataloguePostList.vue?vue&type=script&lang=js&"
export * from "./CataloguePostList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports